fragment FeatureHeadlineFragment on featureHeadline_Entry {
  typeHandle
  tagLine
  heading
}
